import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
interface SearchedJobsResponse {
  "@context": string;
  "@id": string;
  "@type": string;
  "hydra:totalItems": number;
  "hydra:member": string[];
}
export const useRemoveSearchedJob = clubSlug => {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== clubSlug || $[1] !== queryClient) {
    t0 = {
      mutationFn: async jobToRemove => {
        const currentJobs = queryClient.getQueryData(["club", clubSlug, "jobs"]) || [];
        const updatedJobs = currentJobs.filter(job => job !== jobToRemove);
        const response = await fetch("/api/club-jobs", {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            clubSlug,
            searchedJobs: updatedJobs
          })
        });
        if (!response.ok) {
          throw new Error("Erreur lors de la suppression du profil");
        }
        const data = await response.json();
        return data["hydra:member"];
      },
      onSuccess: data_0 => {
        queryClient.setQueryData(["club", clubSlug, "jobs"], data_0);
      }
    };
    $[0] = clubSlug;
    $[1] = queryClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useMutation(t0);
};